const backgroundImages = [
  "/images/chemical-bags.jpg",
  "/images/testing-image.jpg",
  "/images/plantation.jpg",
  "/images/containers.jpg",
];

export default backgroundImages;
